import MarkupEmbeddedVideo from './MarkupEmbeddedVideo'

export default MarkupEmbeddedVideo
